import { render, staticRenderFns } from "./BoxInformation.vue?vue&type=template&id=6bf162fe&scoped=true"
import script from "./BoxInformation.vue?vue&type=script&lang=js"
export * from "./BoxInformation.vue?vue&type=script&lang=js"
import style0 from "./BoxInformation.vue?vue&type=style&index=0&id=6bf162fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf162fe",
  null
  
)

export default component.exports